<template>
  <div class="alarm-general-vision">
    <alarm-general-donut-vision-chart
      icon="icon-red-empty-bell"
      ref="criticalRef"
      chart-name="criticalChart"
      :color="colors.critical"
      :title="$t('dashboard.critical')"
      :chart-data="criticalChartData"
      :loading="loading"
      @onGraphClicked="openAlarmWindow"
    />
    <alarm-general-donut-vision-chart
      icon="icon-yellow-empty-bell"
      ref="urgentRef"
      chart-name="urgentChart"
      :color="colors.urgent"
      :title="$t('dashboard.urgent')"
      :chart-data="urgentChartData"
      :loading="loading"
      @onGraphClicked="openAlarmWindow"
    />
    <alarm-general-donut-vision-chart
      icon="icon-blue-empty-bell"
      ref="ordinaryRef"
      chart-name="ordinaryChart"
      :color="colors.ordinary"
      :title="$t('dashboard.ordinary')"
      :chart-data="ordinaryChartData"
      :loading="loading"
      @onGraphClicked="openAlarmWindow"
    />
  </div>
</template>

<script>
import AlarmGeneralDonutVisionChart from '@/domain/components/generalPanel/dashboard/alarmGeneralVision/AlarmGeneralDonutVisionChart';
import dashboard from '@/domain/services/generalPanel/dashboard';
import translate from '@/services/translate';

const colors = {
  critical: '#D32F2F',
  urgent: '#F9A825',
  ordinary: '#00ACC1',
};

export default {
  name: 'AlarmGeneralDonutVision',
  props: {
    filters: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  components: {
    AlarmGeneralDonutVisionChart,
  },
  data: () => ({
    criticalChartData: [],
    urgentChartData: [],
    ordinaryChartData: [],
    loading: true,
  }),
  computed: {
    colors() {
      return colors;
    },
  },
  methods: {
    loadChartData() {
      this.loading = true;
      dashboard.getGeneralViewByClassification(this.filters)
        .then((response) => {
          this.loading = false;
          this.urgentChartData = this.mapClassification(response, 'urgent');
          this.ordinaryChartData = this.mapClassification(response, 'ordinary');
          this.criticalChartData = this.mapClassification(response, 'critical');

          this.$nextTick(() => {
            this.$refs.criticalRef.setChartData();
            this.$refs.urgentRef.setChartData();
            this.$refs.ordinaryRef.setChartData();
          });
      });
    },
    mapClassification(response, classification) {
      return response.filter(item => item.alarmClassification === classification)
        .flatMap(item => item.getMappedValues())
        .map(item => ({
          ...item,
          name: `${item.value} | ${translate(`enums.alarms.${item.status}`)}`.toUpperCase(),
        }));
    },
    openAlarmWindow(params) {
      this.$emit('onGraphClick', params);
    },
  },
};
</script>

<style scoped lang="sass">
@import "src/styles/defaults/mobile-first"
.alarm-general-vision
  display: flex
  justify-content: space-between
  flex-wrap: wrap
  +media-max-sm()
    flex-direction: column
    align-items: center

</style>
